import React from 'react';
import { Col, Form, message, Modal, Row, Skeleton } from 'antd';

import FormInput from 'components/FormInput/FormInput';
import SectionCard from 'components/SectionCard/SectionCard';

const { useForm } = Form;

const OverrideTotalModal = ({ defaultValues, isLoading, onOk, onCancel, title, visible }) => {
  const [form] = useForm();
  const intialValues = {
    ...defaultValues,
    income: {
      overridingTotal: {
        self: defaultValues.inflow && defaultValues.inflow.self,
        spouse: defaultValues.inflow && defaultValues.inflow.spouse
      }
    },
    expenses: {
      overridingTotal: {
        self: defaultValues.outflow && defaultValues.outflow.self,
        spouse: defaultValues.outflow && defaultValues.outflow.spouse
      }
    }
  };

  const handleOnOkButtonClick = async e => {
    e.preventDefault();
    try {
      const values = await form.validateFields();
      onOk(values);
    } catch (error) {
      error.errorFields.forEach(field => message.error(field.errors[0]));
    }
  };

  return (
    <Modal title={title} visible={visible} okText="Save" onOk={handleOnOkButtonClick} onCancel={onCancel} width="80%">
      <Form form={form} initialValues={intialValues}>
        {isLoading ? (
          <Skeleton active />
        ) : (
          <>
            <Row gutter={16}>
              <Col span={12}>
                <SectionCard title="Self">
                  <Row>
                    <Col span={24}>
                      <FormInput label="Amount" name={['overridingTotal', 'self']} placeholder="0.00" type="financial" />
                    </Col>
                  </Row>
                </SectionCard>
              </Col>
              <Col span={12}>
                <SectionCard title="Spouse">
                  <Row>
                    <Col span={24}>
                      <FormInput label="Amount" name={['overridingTotal', 'spouse']} placeholder="0.00" type="financial" />
                    </Col>
                  </Row>
                </SectionCard>
              </Col>
            </Row>
          </>
        )}
      </Form>
    </Modal>
  );
};

export default OverrideTotalModal;
